import styles from "./opsConsole.module.css";

/**
 * Small pieces shared by the Marketplace ops screens.
 *
 * The identity tile matters more than it looks: a queue of text rows all reads
 * the same, and a reviewer scanning twenty submissions recognises a product by
 * its mark long before they read its name. The API was already returning
 * `logo` — the first build simply never drew it.
 */

/** Deterministic colour from a name, so a tile is stable across renders. */
const PALETTE = [
  "#4285f4", "#0f9d58", "#db4437", "#f4b400",
  "#7c4dff", "#00897b", "#e8710a", "#c2185b",
];
export const tint = (s) => {
  let h = 0;
  const str = String(s || "?");
  for (let i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) | 0;
  return PALETTE[Math.abs(h) % PALETTE.length];
};

export function Tile({ name, src }) {
  if (src) {
    return (
      <img
        src={src}
        alt=""
        className={`${styles.tile} ${styles.tileImg}`}
        onError={(e) => {
          e.currentTarget.style.display = "none";
        }}
      />
    );
  }
  return (
    <span className={styles.tile} style={{ background: tint(name) }}>
      {String(name || "?").charAt(0).toUpperCase()}
    </span>
  );
}

export function Kpi({ value, label, tone = "", icon }) {
  return (
    <div className={`${styles.kpi} ${tone ? styles[tone] : ""}`}>
      <span className={styles.kpiIcon}>{icon}</span>
      <span className={styles.kpiBody}>
        <span className={styles.kpiVal}>{value}</span>
        <span className={styles.kpiLbl}>{label}</span>
      </span>
    </div>
  );
}

/* Inline icons — no new dependency, and they inherit the KPI tone colour. */
const ico = (d) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
       strokeLinecap="round" strokeLinejoin="round">{d}</svg>
);
export const IcoInbox = ico(<><path d="M22 12h-6l-2 3h-4l-2-3H2" /><path d="M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z" /></>);
export const IcoWarn = ico(<><path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" /><path d="M12 9v4M12 17h.01" /></>);
export const IcoShield = ico(<><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /></>);
export const IcoClock = ico(<><circle cx="12" cy="12" r="10" /><path d="M12 6v6l4 2" /></>);
export const IcoStore = ico(<><path d="M3 9h18M5 9V6a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3M4 9v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9" /></>);
export const IcoCheck = ico(<><path d="M20 6 9 17l-5-5" /></>);
